// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getAutoCarriers, getAutoDelivery as getAutoDeliveryService } from "@guestsupply/App/Services/AutoDelivery";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

export type AutoDeliveryProps = {
    productId: string;
};
type HandlerType = ApiHandler<AutoDeliveryProps & HasOnSuccess & HasOnError<string>, any>;

export const GetAutoDeliveryFromApi: HandlerType = async props => {
    const autoDelivery = await getAutoDeliveryService({
        productId: props.parameter.productId,
    });
    props.apiResult = { autoDeliveryData: autoDelivery };
};
export const GetAutoCarriers: HandlerType = async props => {
    const autoCarriers = await getAutoCarriers();
    props.apiResult = { ...props.apiResult, autoCarriersData: autoCarriers };
};
export const chain = [GetAutoDeliveryFromApi, GetAutoCarriers];

const getAutoDelivery = createHandlerChainRunner(chain, "getAutoDelivery");
export default getAutoDelivery;
